import { render, staticRenderFns } from "./coffee-request-card.vue?vue&type=template&id=6c9e133c&scoped=true&"
import script from "./coffee-request-card.vue?vue&type=script&lang=js&"
export * from "./coffee-request-card.vue?vue&type=script&lang=js&"
import style0 from "./coffee-request-card.vue?vue&type=style&index=0&id=6c9e133c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9e133c",
  null
  
)

export default component.exports